import { useState, useEffect } from 'react';
import './SuccessModal.css';

function SuccessModal({ 
  isOpen, 
  onClose, 
  title = 'Success!', 
  subtitle = 'Redirecting you...',
  onComplete,
  delay = 800 
}) {
  const [isClosing, setIsClosing] = useState(false);

  useEffect(() => {
    if (isOpen) {

      const timer = setTimeout(() => {
        setIsClosing(true);
        setTimeout(() => {
          onClose();
          if (onComplete) {
            onComplete();
          }
          setIsClosing(false);
        }, 300); // Fade out duration
      }, delay); // Success animation duration

      return () => clearTimeout(timer);
    }
  }, [isOpen, delay, onClose, onComplete]);

  if (!isOpen) return null;

  return (
    <div className={`success-modal-overlay ${isClosing ? 'modal-closing' : ''}`}>
      <div className={`success-modal-content ${isClosing ? 'modal-closing' : ''}`}>
        <div className="success-modal-header">
          <div className="success-modal-icon">✓</div>
          <h2 className="success-modal-title">{title}</h2>
          <p className="success-modal-subtitle">{subtitle}</p>
        </div>
        <div className="success-modal-body">
          <div className="success-animation">
            <div className="success-checkmark">
              <svg width="80" height="80" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="3">
                <path d="M20 6L9 17l-5-5" strokeLinecap="round" strokeLinejoin="round"/>
              </svg>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default SuccessModal;
